import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ThemeColorName } from '@examdojo/styles';

export type ClassBackgroundSize = 'small' | 'medium' | 'large';

@Component({
  selector: 'dojo-class-background',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'hostClass()',
  },
  styles: [
    `
      .bg-cover {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    `,
  ],
  template: `
    @if (size() === 'small') {
      <img [src]="backgroundSvgSmall()" alt="" class="bg-cover" />
    } @else if (size() === 'medium') {
      <img [src]="backgroundSvgMedium()" alt="" class="bg-cover" />
    } @else {
      <img [src]="backgroundSvg()" alt="" class="bg-cover" />
    }
  `,
})
export class ClassBackgroundComponent {
  readonly color = input<ThemeColorName>('indigo');
  readonly size = input<ClassBackgroundSize>('small');

  protected readonly backgroundSvg = computed(() => `/assets/images/background/default/${this.color()}.svg`);
  protected readonly backgroundSvgMedium = computed(
    () => `/assets/images/background/medium/${this.color()}-medium.svg`,
  );
  protected readonly backgroundSvgSmall = computed(() => `/assets/images/background/small/${this.color()}.svg`);

  protected readonly hostClass = computed(() => {
    const baseClass = 'block relative w-full overflow-hidden';
    switch (this.size()) {
      case 'small':
        return `${baseClass} h-20 rounded-t-[12px]`;
      case 'medium':
        return `${baseClass} h-32 rounded-t-[12px]`;
      case 'large':
        return `${baseClass} h-[130px]`;
      default:
        return `${baseClass} h-20 rounded-t-[12px]`;
    }
  });
}
